import { render, staticRenderFns } from "./OrderWorkflowsTable.vue?vue&type=template&id=62249011&scoped=true"
import script from "./OrderWorkflowsTable.vue?vue&type=script&lang=js"
export * from "./OrderWorkflowsTable.vue?vue&type=script&lang=js"
import style0 from "./OrderWorkflowsTable.vue?vue&type=style&index=0&id=62249011&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62249011",
  null
  
)

export default component.exports